import { __decorate, __metadata } from "tslib";
import { injectable } from 'inversify';
import { computed, makeObservable, observable } from 'mobx';
var RoutingState = /** @class */ (function () {
    function RoutingState() {
        this.observableRoute = null;
        this.currentView = null;
        makeObservable(this);
    }
    Object.defineProperty(RoutingState.prototype, "currentViewFullScreen", {
        get: function () {
            var _a;
            return ((_a = this.currentView) === null || _a === void 0 ? void 0 : _a.fullScreen) === true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoutingState.prototype, "taskRunner", {
        get: function () {
            var _a;
            return (_a = this.currentView) === null || _a === void 0 ? void 0 : _a.taskRunner;
        },
        enumerable: false,
        configurable: true
    });
    RoutingState.prototype.setCurrentRoute = function (routeProps, route) {
        this.currentRouteProps = routeProps;
        this.currentRoute = route;
    };
    RoutingState.prototype.onRouteChanged = function () {
        var _a, _b;
        if (this.previousRoute !== this.currentRoute) {
            this.previousRoute = this.currentRoute;
            this.observableRoute = (_a = this.currentRoute) !== null && _a !== void 0 ? _a : null;
            if (((_b = this.currentView) === null || _b === void 0 ? void 0 : _b.constructor) !== this.currentRoute.component) {
                this.currentView = null;
            }
            // Scroll back to top as if the browser had actually loaded a new page.
            window.scrollTo(0, 0);
        }
        else {
            // Same route, but parameters must have changed.
            if (this.currentView) {
                this.currentView.updateViewParams(this.currentRouteProps.match);
            }
        }
    };
    __decorate([
        observable.ref,
        __metadata("design:type", Object)
    ], RoutingState.prototype, "observableRoute", void 0);
    __decorate([
        observable.ref,
        __metadata("design:type", Object)
    ], RoutingState.prototype, "currentView", void 0);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], RoutingState.prototype, "currentViewFullScreen", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], RoutingState.prototype, "taskRunner", null);
    RoutingState = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], RoutingState);
    return RoutingState;
}());
export { RoutingState };
